import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import GovernanceGate from './GovernanceGate';
import OptOutReaffirmGate from './OptOutReaffirmGate';

interface AdministratorRouteProps {
  children: React.ReactNode;
}

/** Authenticated users with the Administrator role only (same bar as server-side settings APIs). */
export default function AdministratorRoute({ children }: AdministratorRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  if (!user.roles?.includes('Administrator')) {
    return <Navigate to="/dashboard/my" replace />;
  }

  return (
    <GovernanceGate userId={user.id}>
      <OptOutReaffirmGate>
        {children}
      </OptOutReaffirmGate>
    </GovernanceGate>
  );
}
